var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxHeader1"},[_c('div',{staticClass:"boxHeader1Item",on:{"click":function($event){return _vm.toIndex()}}},[_vm._v("首页")]),_vm._l((_vm.classList),function(cls){return _c('div',{staticClass:"boxHeader1Item",on:{"click":function($event){return _vm.toGameList(cls.id)}}},[_vm._v(" "+_vm._s(cls.name)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }